<h1 mat-dialog-title class="se-dialog-header">{{ data.message }}</h1>
<div mat-dialog-content class="se-assign-equipment-dialog-content">
    @if (form) {
        <div [formGroup]="form">
            <mat-form-field appearance="outline">
                <mat-label>{{ "Equipment" | translate }}</mat-label>
                <mat-select matInput [placeholder]="'Equipment' | translate" formControlName="equipment">
                    <mat-option>
                        <ngx-mat-select-search
                            formControlName="equipmentFilterCtrl"
                            [noEntriesFoundLabel]="'NoResults' | translate"
                            [placeholderLabel]="'Search' | translate"
                        ></ngx-mat-select-search>
                    </mat-option>
                    @for (item of filteredEquipments$ | async; track item.guid) {
                        <mat-option [value]="item.guid">
                            <span>{{ item.description }} </span>
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    }
    @if (isWaiting) {
        <div class="is-waiting"><mat-spinner></mat-spinner></div>
    }
</div>
<mat-dialog-actions class="dialog-actions">
    <button (click)="closeDialog()" color="primary" mat-button mat-dialog-close [disabled]="isWaiting">
        {{ cancelLabel | translate }}
    </button>
    <button (click)="confirm()" color="primary" mat-button [disabled]="!form?.valid || isWaiting">
        {{ confirmLabel | translate }}
    </button>
</mat-dialog-actions>
